window.ucfirst = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

window.setCookieValue = function(n,v){
    // If we have localStorage available, use it
    if (typeof Storage !== void(0)) {
        var v = window.localStorage.setItem(n, v);
        return true;
    }
    // If no localStorage, fallback to cookies
    Cookies.set(n, v);
    return true;
}

window.getCookieValue = function(n) {
    // If we have localStorage available, use it
    if (typeof Storage !== void(0)) {
        var v = window.localStorage.getItem(n);
        if (v == null) {
            return '';
        }
        return v;
    }
    // If no localStorage, fallback to cookies
    var c = Cookies.get(n);
    if (typeof c == 'undefined' ) {
        return '';
    }
    return c;
}

let animating = false;
let STR_PAD_LEFT = 1;
let STR_PAD_RIGHT = 2;
let STR_PAD_BOTH = 3;
window.customerLat = getCookieValue('lat');
window.customerLng = getCookieValue('lng');
window.customerPostcode = getCookieValue('postcode');
window.customerGeolocation = getCookieValue('geolocation');

window.closest = function(num, arr) {
    var curr = arr[0];
    var diff = Math.abs (num - curr);
    for (var val = 0; val < arr.length; val++) {
        var newdiff = Math.abs (num - arr[val]);
        if (newdiff < diff) {
            diff = newdiff;
            curr = arr[val];
        }
    }
    return curr;
}

window.arrayChunk = function(arr, chunkSize) {
    var groups = [], i;
    for (i = 0; i < arr.length; i += chunkSize) {
        groups.push(arr.slice(i, i + chunkSize));
    }
    return groups;
};

window.pad = function(str, len, pad, dir) {

    if (typeof(len) == "undefined") { var len = 0; }
    if (typeof(pad) == "undefined") { var pad = ' '; }
    if (typeof(dir) == "undefined") { var dir = STR_PAD_RIGHT; }
    if (len + 1 >= str.length) {
        switch (dir){

            case STR_PAD_LEFT:
                str = Array(len + 1 - str.length).join(pad) + str;
            break;

            case STR_PAD_BOTH:
                var right = Math.ceil((padlen = len - str.length) / 2);
                var left = padlen - right;
                str = Array(left+1).join(pad) + str + Array(right+1).join(pad);
            break;

            default:
                str = str + Array(len + 1 - str.length).join(pad);
            break;

        } // switch

    }

    return str;
}

window.cleanse_number = function(n) {
    if (typeof n == 'number') {
        return n;
    }

    if (typeof n == 'string') {
        return parseFloat(n.replace(/[^\d.-]/g, ''));
    }

    return 0;
}

window.number_format = function(number, decimals, dec_point, thousands_sep) {
  number = (number + '')
    .replace(/[^0-9+\-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
    dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
    s = '',
    toFixedFix = function(n, prec) {
      var k = Math.pow(10, prec);
      return '' + (Math.round(n * k) / k)
        .toFixed(prec);
    };
  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
    .split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || '')
    .length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1)
      .join('0');
  }
  return s.join(dec);
}

window.getValueFromRadio = function(name)
{
    var selectedVal = "";
    var selected = $("input[type='radio'][name='"+name+"']:checked");
    if (selected.length > 0) {
        selectedVal = selected.val();
    }
    return selectedVal;
}

window.parseErrorResponse = function(response)
{
    if (typeof response.status !== 'undefined' && response.status == 500)  {
        return {"form":["Sorry, an unknown error has occurred, please check your details and try again"]};
    }
    else if (typeof response.responseText !== 'undefined') {
        try {
            var data = JSON.parse(response.responseText);
            return data;
        } catch (error) {
            return {"form":["Sorry, an unknown error has occurred, please check your details and try again"]};
        }
    }
    return {"form":["Sorry, an unknown error has occurred, please check your details and try again"]};
}

window.outputErrorToForm = function(formId, data)
{
    $('#'+formId+'-alert').remove();

    var e = [];

    $.each( data, function( key, error ) {
        if (typeof error == 'string' && error != '') {
            e.push('<li>'+ error +'</li>');
        }
    });

    if (e.length == 0) {
        e.push('<li>An unknown error has occurred, please try refreshing the page</li>');
    }

    $('#'+formId).prepend('<div class="alert alert-danger" id="'+formId+'-alert"><ul>' + e.join('') + '</ul></div>');
}

window.isScrolledIntoView = function(elem)
{
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $('#'+elem).offset().top;
    var elemBottom = elemTop + $('#'+elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

window.scrollToElementId = function(elementID)
{
    return new Promise((resolve, reject) => {
        if (animating || isScrolledIntoView(elementID)) {
            resolve('already_in_view');
        }

        animating = true;
        // Offset based on header height
        const offset = ($(window).width() < 992) ? 56 : 125;

        $('html, body').animate({
            scrollTop: ($('#'+elementID).offset().top-offset)},
            250,
            function() {
                animating = false;
                resolve('finished_scrolling');
            }
        );
    });
}

window.updateCompareCount = function(num)
{
    let count = parseInt(num) || 0;
    $('.compare-count .count, .mega-menu__link--small .count').html('(' + count + ') ');
}

jQuery(document).ready(function($){
    // Generic accord link handler
    // Add accord-link to your element, with a data-target attribute having a query selector as it's value, and it will toggle the target element
    $('.accord-link').on('click.accord', function() {
        const toggler = $(this);
        const target = toggler.data('target');
        if (document.querySelector(target)) {
            const e = $(target);
            e.slideToggle(400, 'swing', function() {
                if (e.is(':visible')) {
                    $(this).addClass('open');
                    toggler.removeClass('collapsed');
                    return true;
                }
                $(this).removeClass('open');
                toggler.addClass('collapsed');
            }.bind(this));
        }
    });
});


// WEBPACK FOOTER //
// ./resources/assets/js/general-functions.js